__webpack_require__.p = "/wp-content/themes/updater-starter-child/dist/";